// Mirrors the `account` demographics `state` enum (see
// account/docs/demographics/schema.json), including the military codes
// AA/AE/AP. 55 values total: 50 states + DC + PR + AA/AE/AP.
export const US_STATE_ABBREVIATIONS: string[] = [
	'AA',
	'AE',
	'AK',
	'AL',
	'AP',
	'AR',
	'AZ',
	'CA',
	'CO',
	'CT',
	'DC',
	'DE',
	'FL',
	'GA',
	'HI',
	'IA',
	'ID',
	'IL',
	'IN',
	'KS',
	'KY',
	'LA',
	'MA',
	'MD',
	'ME',
	'MI',
	'MN',
	'MO',
	'MS',
	'MT',
	'NC',
	'ND',
	'NE',
	'NH',
	'NJ',
	'NM',
	'NV',
	'NY',
	'OH',
	'OK',
	'OR',
	'PA',
	'PR',
	'RI',
	'SC',
	'SD',
	'TN',
	'TX',
	'UT',
	'VA',
	'VT',
	'WA',
	'WI',
	'WV',
	'WY',
];

// Full names for each abbreviation above, used as choiceLabels so filters
// display e.g. "California" instead of the raw "CA" code.
export const US_STATE_ABBREVIATIONS_TO_NAMES: Record<string, string> = {
	AA: 'Armed Forces Americas',
	AE: 'Armed Forces Europe',
	AK: 'Alaska',
	AL: 'Alabama',
	AP: 'Armed Forces Pacific',
	AR: 'Arkansas',
	AZ: 'Arizona',
	CA: 'California',
	CO: 'Colorado',
	CT: 'Connecticut',
	DC: 'District of Columbia',
	DE: 'Delaware',
	FL: 'Florida',
	GA: 'Georgia',
	HI: 'Hawaii',
	IA: 'Iowa',
	ID: 'Idaho',
	IL: 'Illinois',
	IN: 'Indiana',
	KS: 'Kansas',
	KY: 'Kentucky',
	LA: 'Louisiana',
	MA: 'Massachusetts',
	MD: 'Maryland',
	ME: 'Maine',
	MI: 'Michigan',
	MN: 'Minnesota',
	MO: 'Missouri',
	MS: 'Mississippi',
	MT: 'Montana',
	NC: 'North Carolina',
	ND: 'North Dakota',
	NE: 'Nebraska',
	NH: 'New Hampshire',
	NJ: 'New Jersey',
	NM: 'New Mexico',
	NV: 'Nevada',
	NY: 'New York',
	OH: 'Ohio',
	OK: 'Oklahoma',
	OR: 'Oregon',
	PA: 'Pennsylvania',
	PR: 'Puerto Rico',
	RI: 'Rhode Island',
	SC: 'South Carolina',
	SD: 'South Dakota',
	TN: 'Tennessee',
	TX: 'Texas',
	UT: 'Utah',
	VA: 'Virginia',
	VT: 'Vermont',
	WA: 'Washington',
	WI: 'Wisconsin',
	WV: 'West Virginia',
	WY: 'Wyoming',
};
